<template>
  <div>
    <div class="outer-title">
      <div>
        <p class="title" style="display: inline-block; fontsize: 14px">
          转入课信息
        </p>
        <p
          class="tips mwow-yellow"
          style="display: inline-block; margin-left: 14px"
        >
          默认为学员自己课程互转，或选择转给其他学员；
        </p>
      </div>
      <!-- 转入学员 -->
      <div style="display: flex; align-items: flex-start">
        <el-form size="mini" :model="transfer" inline>
          <el-form-item label="转入学员">
            <el-radio-group
              v-model="transfer.transferType"
              @change="handleChangeTransfer"
            >
              <el-radio-button :label="1">自己</el-radio-button>
              <el-radio-button :label="2">其他学员</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div v-show="transfer.transferType === 2" class="select-student">
          <div class="in cu-po" @click="showStudentDialog">选择学员</div>
          <div class="info" v-show="transfer.student_info.length">
            <p>
              {{
                transfer.student_info.length > 0
                  ? transfer.student_info[0].name
                  : "-"
              }}
            </p>
            <p></p>
            <p>
              +{{
                transfer.student_info.length > 0
                  ? transfer.student_info[0].area_code +
                    " " +
                    transfer.student_info[0].mobile
                  : "-"
              }}
            </p>
            <i class="el-icon-delete-solid cu-po" @click="delStudentList"></i>
          </div>
        </div>
      </div>
      <div>
        <el-button class="mwow-button-filled success" @click="showDialog"
          >添加转入课程</el-button
        >
        <p
          class="tips mwow-yellow"
          style="display: inline-block; margin-left: 14px"
        >
          转出课金额，自动与转入课金额对冲，并根据转入的课时数多退少补。
        </p>
      </div>
    </div>
    <div class="table-wrap mwow-table">
      <div class="th row-6">
        <div class="td">内容价格</div>
        <div class="td">转入课时</div>
        <div class="td">业务形式</div>
        <div class="td">直减</div>
        <div class="td">小计</div>
        <div class="td">操作</div>
      </div>
      <div class="no-data" v-if="selectedCourse.length === 0">
        请选择购买内容
      </div>
      <div
        class="item"
        v-for="(item, index) in selectedCourse"
        :key="item.course_id"
      >
        <div class="title">
          <p class="text">【课程】- {{ item.title }}</p>
          <div class="delete-btn-wrap">
            <div class="btn" @click="handleCourseDelete(index)">删除</div>
          </div>
        </div>
        <div class="tr row-6">
          <div class="td">
            <el-select
              v-model="item.option_id"
              @change="
                (v) => {
                  let target = allSpecObject[v];
                  item.option_id = target.course_spec_id;
                  item.input_quantity = target.quantity;
                  item.course_spec_quantity = target.quantity;
                  item.course_spec_name = target.course_spec_name;
                  item.unit_price = target.unit_price;
                  item.price = target.price;
                  handleCourseRowSum(index);
                }
              "
            >
              <el-option
                v-for="it in item.item_list"
                :key="it.course_spec_id"
                :label="it.course_spec_name"
                :value="it.course_spec_id"
              ></el-option>
            </el-select>
          </div>
          <div class="td">
            <el-input
              type="number"
              v-model="item.input_quantity"
              @change="
                (v) => {
                  if (Number(v) < 0) {
                    item.input_quantity = 0;
                  } else {
                    item.input_quantity = Number(v).toFixed(2);
                  }
                  handleCourseRowSum(index);
                }
              "
              :disabled="Number(item.course_spec_quantity) !== 1"
              placeholder="请输入"
              style="width: 65%"
            ></el-input>
          </div>
          <div class="td">
            <p v-if="item.business_type === 0">-</p>
            <p v-if="item.business_type === 1">新购</p>
            <p v-if="item.business_type === 2">续费</p>
            <p v-if="item.business_type === 3">拓科</p>
          </div>
          <div class="td">
            <el-select
              v-model="item.discount_type"
              class="discount-select"
              @change="
                () => {
                  handleCourseRowSum(index);
                }
              "
              placeholder=""
            >
              <el-option label="直减" :value="0"></el-option>
            </el-select>
            <el-input
              v-model="item.discount_number"
              class="discount-input"
              type="number"
              @change="
                (v) => {
                  if (Number(v) > 9999999) {
                    item.discount_number = 0;
                  } else if (Number(v) < 0) {
                    item.discount_number = 0;
                  } else {
                    item.discount_number = Number(v).toFixed(2);
                  }
                  handleCourseRowSum(index);
                }
              "
              ><template slot="prepend"
                ><span style="font-weight: 400">￥</span></template
              ></el-input
            >
          </div>
          <div class="td">
            <span class="mwow-red" style="font-weight: 400"
              >￥{{ item.total / 100 || 0 }}</span
            >
          </div>
          <div class="td"></div>
        </div>
        <div class="date-wrap">
          <span class="label">课程有效期：</span>
          <el-date-picker
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            v-model="item.effective_time"
            :picker-options="effectiveTimeOption"
          >
          </el-date-picker>
          <el-tooltip
            effect="dark"
            content="超过有效期的课程，会显示过期标签"
            placement="top"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加课程"
      :visible.sync="dialogVisible"
      append-to-body
      width="656px"
      @close="handleDialogCancel"
    >
      <el-form size="mini" :model="searchInfo" inline @submit.native.prevent>
        <el-form-item label="课程名称" prop="title">
          <el-input
            v-model="searchInfo.title"
            placeholder="请输入"
            @change="handleSearch"
            prefix-icon="el-icon-search"
            clearable
            maxlength="99"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-selected-list">
        <p class="title">
          已选课程：已选择<span class="mwow-green">{{
            dialogSelectedCourse.length
          }}</span
          >个
        </p>
        <div class="tabs">
          <span
            class="tab"
            v-for="item in dialogSelectedCourse"
            :key="item.course_id"
            >{{ item.title
            }}<i
              class="el-icon-error"
              @click="handleDialogCourseDelete(item)"
            ></i
          ></span>
        </div>
      </div>
      <el-table
        size="mini"
        v-horizontal-scroll
        :data="tableData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        class="mwow-table micro"
      >
        <el-table-column width="42" align="center">
          <template slot-scope="scope">
            <!-- <el-checkbox
              v-model="scope.row.checked"
              @change="handleDialogCourseCheck(scope.row)"
              :disabled="scope.row.course_id === originCourseId"
            ></el-checkbox> -->
            <el-checkbox
              v-model="scope.row.checked"
              @change="handleDialogCourseCheck(scope.row)"
              :disabled="
                transfer.transferType === 1 &&
                scope.row.course_id === originCourseId
              "
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="课程名称" prop="title">
          <template slot-scope="scope">
            {{ scope.row.title || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="科目"
          prop="subject_name"
          width="140"
        ></el-table-column>
        <el-table-column label="课程类型" prop="course_type" width="80">
          <template slot-scope="scope">
            {{ scope.row.course_type === 1 ? "1vN" : "1v1" }}
          </template>
        </el-table-column>
      </el-table>
      <div style="overflow: hidden">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :page-count="5"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="dialog-footer">
        <div class="btns">
          <el-button class="mwow-button-filled mini" @click="handleDialogCancel"
            >取消</el-button
          >
          <el-button
            class="mwow-button-filled success mini"
            @click="handleDialogConfirm"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 选择学员弹框 -->
    <el-dialog
      title="选择学员"
      :visible.sync="dialogStudentVisible"
      append-to-body
      width="656px"
      destroy-on-close
      @close="handleStudentDialogCancel"
    >
      <el-form size="mini" :model="transfer" inline @submit.native.prevent>
        <el-form-item label="学员姓名" prop="title">
          <el-input
            v-model="transfer.title"
            placeholder="请输入"
            @change="handleSearchStudent"
            prefix-icon="el-icon-search"
            clearable
            maxlength="99"
          ></el-input>
        </el-form-item>
        <el-form-item label="学员状态" prop="student_type">
          <el-radio-group
            v-model="transfer.student_type"
            @change="handleSearchStudent"
          >
            <el-radio-button :label="-1">全部</el-radio-button>
            <el-radio-button :label="2">在读</el-radio-button>
            <el-radio-button :label="3">历史</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-selected-list">
        <p class="title">
          已选学员：已选择<span class="mwow-green">{{
            dialogSelectedStudent.length
          }}</span
          >个
        </p>
        <div class="tabs">
          <span
            class="tab"
            v-for="item in dialogSelectedStudent"
            :key="item.student_id"
            >{{ item.name || "-"
            }}<i
              class="el-icon-error"
              @click="handleDialogStudentDelete(item)"
            ></i
          ></span>
        </div>
      </div>
      <el-table
        size="mini"
        v-horizontal-scroll
        :data="tableStudentData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        class="mwow-table micro"
      >
        <el-table-column width="42" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.checked"
              @change="handleDialogStudentCheck(scope.row)"
              :disabled="scope.row.student_id === Number($route.query.sid)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="学员姓名" prop="title">
          <template slot-scope="scope">
            {{ scope.row.name || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="学员状态" prop="status">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 2">在读</div>
            <div v-if="scope.row.status === 3">历史</div>
          </template>
        </el-table-column>
        <el-table-column label="入学时间" prop="transform_time">
        </el-table-column>
      </el-table>
      <div style="overflow: hidden">
        <el-pagination
          small
          :current-page="studentPage"
          :page-size="studentPageSize"
          :page-sizes="studentPageSizeArray"
          :page-count="5"
          :style="{ float: 'right', padding: '20px' }"
          :total="studentTotal"
          @current-change="handleStudentPagerChange"
          @size-change="handleStudentPagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="dialog-footer">
        <div class="btns">
          <el-button
            class="mwow-button-filled mini"
            @click="handleStudentDialogCancel"
            >取消</el-button
          >
          <el-button
            class="mwow-button-filled success mini"
            @click="handleStudentDialogConfirm"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { solveLargeNumber } from "@/utils/common";
import { courseSpecList, studentCourseDetailApi } from "@/api/course";
import { getSelectCourseList, searchStudent } from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
export default {
  props: ["originData", "originCourseId"],
  data() {
    return {
      selectedCourse: [], // 转入课信息
      dialogSelectedCourse: [], // 弹窗选中课程
      dialogVisible: false,
      searchInfo: {
        title: "",
      },
      tableData: [], // 弹窗当前页内容
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      studentPage: 1,
      studentPageSize: 10,
      studentPageSizeArray: [5, 10, 30, 50, 100],
      studentTotal: 0,
      studentList: 0,
      courseSpecObject: {}, // 根据课程id缓存规格列表
      allSpecObject: {}, // 根据规格id缓存规格详情
      allCoursePrice: 0, // 全部课程小计总计
      courseIds: [],
      dialogStudentVisible: false, // 选择学员弹框
      transfer: {
        transferType: 1, // 转入学员选择
        title: "",
        student_type: -1,
        student_info: [],
      },
      dialogSelectedStudent: [], // 弹窗选中学员
      tableStudentData: [],
      effectiveTimeOption: {
        disabledDate: (date) => {
          return date.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    delStudentList() {
      this.dialogSelectedStudent = [];
      this.transfer.student_info = [];
      this.$message({
        type: "success",
        message: "删除成功",
      });
    },
    handleStudentDialogCancel() {
      this.dialogStudentVisible = false;
      if (this.transfer.student_info.length === 0) {
        this.dialogSelectedStudent = [];
      }
    },
    handleStudentDialogConfirm() {
      if (this.dialogSelectedStudent) {
        this.transfer.student_info = this.dialogSelectedStudent;
        this.dialogStudentVisible = false;
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.$emit("changeStudentInfo", this.transfer);
      }
    },
    showStudentDialog() {
      this.getStudentList({
        page: this.studentPage,
        page_size: this.studentPageSize,
      });
    },
    getStudentList(val) {
      const params = {
        page: val.page,
        page_size: val.page_size,
      };
      if (this.transfer.title) {
        params.key_word = this.transfer.title;
      }
      if (this.transfer.student_type > 0) {
        params.status = [this.transfer.student_type];
      } else {
        params.status = [2, 3];
      }
      searchStudent(params).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((it) => {
            if (
              this.transfer.student_info.length > 0 &&
              this.transfer.student_info[0].student_id === it.student_id
            ) {
              it.checked = true;
              this.dialogSelectedStudent = this.transfer.student_info;
            } else {
              it.checked = false;
            }
            if (it.transform_time) {
              it.transform_time = dateFormat(
                "YYYY-mm-dd",
                it.transform_time * 1000
              );
            }
          });
          this.tableStudentData = res.data.list;
          this.studentTotal = res.data.total;
          this.dialogStudentVisible = true;
        }
      });
    },
    handleSearchStudent() {
      this.getStudentList({
        page: 1,
        page_size: this.studentPageSize,
      });
    },
    handleStudentPagerChange(e) {
      this.studentPage = e;
      this.getStudentList({
        page: e,
        page_size: this.studentPageSize,
      });
    },
    handleStudentPagerSizeChange(e) {
      this.studentPageSize = e;
      this.getStudentList({
        page: 1,
        page_size: e,
      });
    },
    handleChangeTransfer() {
      this.$emit("changeStudentInfo", this.transfer);
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        sales_status: 1,
      };
      if (this.searchInfo.title) {
        option.title = this.searchInfo.title;
      }
      getSelectCourseList(option).then((res) => {
        res.data.list.map((item) => {
          if (
            this.dialogSelectedCourse.findIndex((it) => {
              return it.course_id === item.course_id;
            }) >= 0
          ) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = res.data.page;
      });
    },
    showDialog() {
      this.dialogSelectedCourse = [...this.selectedCourse];
      this.searchInfo.title = "";
      this.dialogVisible = true;
      this.handleSearch();
      this.courseIds = [];
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    // 弹窗已选课程删除
    handleDialogCourseDelete(item) {
      const copy = [...this.dialogSelectedCourse];
      const i = copy.findIndex((it) => {
        return it.course_id === item.course_id;
      });
      const j = this.tableData.findIndex((it) => {
        return it.course_id === item.course_id;
      });
      copy.splice(i, 1);
      if (j >= 0) {
        this.tableData[j].checked = false;
      }
      this.dialogSelectedCourse = copy;
    },
    // 弹窗表格内课程checked
    handleDialogCourseCheck(item) {
      const copy = [...this.tableData];
      copy.map((it) => {
        if (it.course_id === item.course_id) {
          this.dialogSelectedCourse = [item];
        } else {
          it.checked = false;
        }
      });
      this.tableData = copy;
    },
    // 弹窗已选学员删除
    handleDialogStudentDelete(item) {
      const copy = [...this.tableStudentData];
      this.dialogSelectedStudent = [];
      copy.map((it) => {
        it.checked = false;
      });
      this.tableStudentData = copy;
    },
    // 弹窗表格内学员checked
    handleDialogStudentCheck(item) {
      const copy = [...this.tableStudentData];
      copy.map((it) => {
        if (it.student_id === item.student_id) {
          this.dialogSelectedStudent = [item];
        } else {
          it.checked = false;
        }
      });
      this.tableStudentData = copy;
    },
    handleDialogCancel() {
      // 弹窗取消时不处理数据
      this.dialogVisible = false;
    },
    handleDialogConfirm() {
      // 对比弹窗已选课程和外部已添加课程
      const res = [];
      this.dialogSelectedCourse.map((item) => {
        const index = this.selectedCourse.findIndex((it) => {
          return item.course_id === it.course_id;
        });
        if (index >= 0) {
          res.push(this.selectedCourse[index]);
        } else {
          // 设置默认值可以被template识别进行双向数据绑定
          res.push({
            course_id: item.course_id,
            title: item.title,
            item_list: [],
            option_id: "",
            input_quantity: "0",
            course_spec_quantity: "0",
            course_spec_name: "",
            unit_price: "0",
            price: "0",
            discount_type: 0,
            discount_number: "0",
            total: "",
            effective_time: "",
            business_type: 0,
          });
        }
      });
      this.selectedCourse = res;
      this.dialogVisible = false;
      // 获取所选课程的规格列表并缓存
      const requests = res.map((item) => {
        this.courseIds.push(item.course_id);
        if (this.courseSpecObject[item.course_id]) {
          return new Promise((resolve) => {
            resolve({
              data: {
                list: this.courseSpecObject[item.course_id],
              },
            });
          });
        } else {
          return courseSpecList({ course_id: item.course_id });
        }
      });
      Promise.all(requests).then((arr) => {
        res.map((item, index) => {
          if (!this.courseSpecObject[item.course_id]) {
            this.courseSpecObject[item.course_id] = arr[index].data.list;
          }
          arr[index].data.list.map((spec) => {
            if (!this.allSpecObject[spec.course_spec_id]) {
              this.allSpecObject[spec.course_spec_id] = spec;
            }
          });
          this.selectedCourse[index].item_list = arr[index].data.list;
          // 选中第一项
          const target = arr[index].data.list[0];
          this.selectedCourse[index].option_id = target.course_spec_id;
          this.selectedCourse[index].input_quantity = target.quantity;
          this.selectedCourse[index].course_spec_quantity = target.quantity;
          this.selectedCourse[index].course_spec_name = target.course_spec_name;
          this.selectedCourse[index].unit_price = target.unit_price;
          this.selectedCourse[index].price = target.price;
          this.handleCourseRowSum(index);
        });
      });
      this.getStudentBusinessType();
      this.handleEmit();
    },
    getStudentBusinessType() {
      studentCourseDetailApi({
        student_id: Number(this.$route.query.sid),
        course_ids: this.courseIds,
      }).then((res) => {
        const obj = {};
        const num = [];
        res.data.list.map((item, index) => {
          obj["key" + index] = item;
          num.push(index);
        });
        this.selectedCourse.map((item, index) => {
          for (let i = 0; i < num.length; i++) {
            if (item.course_id === obj["key" + i].course.course_id) {
              item.business_type = obj["key" + i].business_type;
            }
          }
        });
      });
    },
    // 已选课程删除
    handleCourseDelete(i) {
      const copy = [...this.selectedCourse];
      copy.splice(i, 1);
      this.selectedCourse = copy;
      this.handleEmit();
    },
    // 单行小计
    handleCourseRowSum(index) {
      const target = this.selectedCourse[index];
      const quantity = solveLargeNumber(target.input_quantity);
      const price = solveLargeNumber(target.price);
      const unit = solveLargeNumber(target.unit_price);
      const discount = solveLargeNumber(target.discount_number);
      let total = 0;
      if (Number(target.course_spec_quantity) === 1) {
        total = Math.ceil((unit * quantity - discount * 100) / 100);
      } else {
        total = price - discount; // 多个课时时用总价
      }
      // 检查小计是否负数
      if (total < 0) {
        this.selectedCourse[index].discount_number = 0;
        this.$message({
          type: "warning",
          message: "直减金额不能大于转入课金额",
        });
        this.handleCourseRowSum(index);
      } else {
        this.selectedCourse[index].total = total;
        this.handleCourseAllSum();
      }
    },
    // 列表总计
    handleCourseAllSum() {
      let res = 0;
      this.selectedCourse.map((item) => {
        res = res + item.total;
      });
      this.allCoursePrice = res / 100;
      this.handleEmit();
    },
    handleEmit() {
      this.$emit("update:originData", {
        // 如果选中的课程列表没数据，则应付金额为 0
        shouldPay: this.selectedCourse.length ? this.allCoursePrice : 0,
        // shouldPay: this.allCoursePrice,
        courseList: [...this.selectedCourse],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.outer-title {
  margin-bottom: 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #5c5d5e;
    line-height: 20px;
    margin-bottom: 16px;
  }
  .select-student {
    display: flex;
    align-items: center;
    height: 30px;
    .in {
      min-width: 50px;
      font-size: 12px;
      color: #07d1aa;
      margin-right: 25px;
    }
    .info {
      flex: 1;
      height: 100%;
      padding-left: 10px;
      // background-color: skyblue;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      display: flex;
      font-size: 12px;
      color: #5c5d5e;
      align-items: center;
      white-space: nowrap;
      :nth-child(2) {
        height: 26px;
        background-color: #e7e8ea;
        width: 1px;
        margin: 0 5px;
      }
      :nth-child(4) {
        font-size: 16px;
        margin: 0 10px;
      }
    }
  }
}
.table-wrap {
  .no-data {
    font-size: 14px;
    text-align: center;
    color: #5c5d5e;
    padding: 12px;
  }
  .th {
    background-color: #f2f6fa;
    font-size: 12px;
    color: #5c5d5e;
    margin-bottom: 14px;
    display: flex;
    line-height: 42px;
    align-items: center;
    font-weight: bold;
    padding-left: 38px;
  }
  .item {
    border: 1px solid #e1e5e9;
    margin-bottom: 14px;
    .title {
      padding: 0 31px;
      background: #f2f6fa;
      display: flex;
      align-items: center;
      .text {
        line-height: 42px;
        font-size: 14px;
        color: #5c5d5e;
        font-weight: bold;
        flex: 12;
      }
      .delete-btn-wrap {
        text-align: right;
        flex: 1;
        .btn {
          width: 40px;
          text-align: center;
          line-height: 22px;
          background: #ffffff;
          border: 1px solid #e7e8ea;
          border-radius: 4px;
          font-size: 12px;
          color: #ffb940;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
    .tr {
      color: #5c5d5e;
      font-size: 12px;
      display: flex;
      line-height: 42px;
      font-weight: bold;
      align-items: center;
      padding-left: 38px;
      /deep/.td {
        &.red {
          .el-input__inner {
            color: #f56c6c !important;
          }
        }
      }
    }
    .date-wrap {
      padding-left: 38px;
      line-height: 42px;
      background-color: #f6fafc;
      color: #5c5d5e;
      font-size: 12px;
      i {
        color: #bebfc0;
        font-size: 14px;
        margin-left: 6px;
        cursor: pointer;
      }
    }
  }
  .row-6 {
    .td:nth-child(1) {
      flex: 2;
    }
    .td:nth-child(2) {
      flex: 3;
    }
    .td:nth-child(3) {
      flex: 3;
    }
    .td:nth-child(4) {
      flex: 3;
    }
    .td:nth-child(5) {
      flex: 3;
    }
    .td:nth-child(6) {
      flex: 1;
      text-align: right;
      padding-right: 39px;
    }
  }
  /deep/ .discount-select {
    position: relative;
    width: 75px !important;
    .el-input {
      width: 75px !important;
    }
    .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
    }
    &::after {
      content: "";
      height: 14px;
      width: 1px;
      background: #e7e8ea;
      position: absolute;
      right: 0;
      top: 15px;
    }
  }
  /deep/ .discount-input {
    width: 80px !important;
    .el-input-group__prepend {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
      background: #ffffff;
      padding: 0 2px 0 10px !important;
    }
    .el-input__inner {
      padding-left: 2px !important;
      border-left: 0;
    }
  }
}
.dialog-selected-list {
  line-height: 13px;
  font-size: 12px;
  color: #5c5d5e;
  .title {
    margin-bottom: 14px;
    span {
      margin: 0 4px;
    }
  }
  .tabs {
    margin-left: 60px;
    .tab {
      color: #07d1aa;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      line-height: 28px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 14px;
      display: inline-block;
      i {
        margin-left: 4px;
        cursor: pointer;
        color: #d8d8d8;
      }
    }
  }
}
.dialog-footer {
  margin: 0 -20px;
  border-top: 1px solid #e7e8ea;
  padding: 20px 20px 0 20px;
  .btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
</style>
